<header></header>
<side-nav></side-nav>
<div class="container fd-accreditation-container">
    <router-outlet></router-outlet>
</div>